// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IconInputField_iconInputUnit__F1nUy {
  flex-wrap: nowrap;
  width: 100%;
  display: flex;
  margin-top: 15px;
}

.IconInputField_iconBackground__zzwmJ {
  width: auto;
  background-color: #154c79;
  padding: 8px;
  border-radius: 12px 0 0 12px;
  align-items: center;
}

.IconInputField_smallIconBackground__g1LoH {
  background-color: #154c79;
  padding: 5px 8px 8px 8px;
  border-radius: 8px 0 0 8px;
}

.IconInputField_icon__u3XxC {
  width: 54px;
  height: 41px;
  color: #ffffff;
  background: #154c79;
}

.IconInputField_smallIcon__EqSf5 {
  width: 32px;
  height: 25px;
  color: #ffffff;
  background: #154c79;
}

.IconInputField_entryForm__PX5Y5 {
  height: 60px;
  border-radius: 0 12px 12px 0;
  font-size: 18px;
}

.IconInputField_smallEntryForm__KVSlt {
  height: 40px;
  border-radius: 0 8px 8px 0;
  border-color: #aaaaaa;
  border-width: 1px;
  border-style: solid;
  font-size: 15px;
}

.IconInputField_inputMessage__C\\+mle {
  text-align: start;
  margin-left: 60px;
  font-size: 16px;
  color: #aaaaaa;
}

.IconInputField_smallInputMessage__POBNh {
  text-align: start;
  margin: 1px 0 0 17px;
  font-size: 13px;
  color: #aaaaaa;
}`, "",{"version":3,"sources":["webpack://./src/components/common/IconInputField/IconInputField.module.scss","webpack://./src/styles/_colors.scss"],"names":[],"mappings":"AAEA;EACE,iBAAA;EACD,WAAA;EACA,aAAA;EACA,gBAAA;AADD;;AAIA;EACE,WAAA;EACA,yBCYgB;EDXhB,YAAA;EACA,4BAAA;EACA,mBAAA;AADF;;AAGA;EACE,yBCMgB;EDLhB,wBAAA;EACA,0BAAA;AAAF;;AAIA;EACC,WAAA;EACA,YAAA;EACC,cAAA;EACD,mBCJiB;ADGlB;;AAGA;EACC,WAAA;EACA,YAAA;EACC,cCNY;EDOb,mBCViB;ADUlB;;AAGA;EACE,YAAA;EACA,4BAAA;EACA,eAAA;AAAF;;AAEA;EACE,YAAA;EACA,0BAAA;EACA,qBCnCW;EDoCX,iBAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,cC7CW;AD8Cb;;AACA;EACE,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,cCnDW;ADqDb","sourcesContent":["@import '../../../styles/colors';\n\n.iconInputUnit {\n  flex-wrap: nowrap;\n\twidth: 100%;\n\tdisplay: flex;\n\tmargin-top: 15px;\n}\n\n.iconBackground {\n  width: auto;\n  background-color: $dark-blue-color;\n  padding: 8px;\n  border-radius: 12px 0 0 12px;\n  align-items: center;\n}\n.smallIconBackground {\n  background-color: $dark-blue-color;\n  padding: 5px 8px 8px 8px;\n  border-radius: 8px 0 0 8px;\n  // align-items: center;\n}\n\n.icon {\n\twidth: 54px;\n\theight: 41px;\n  color: $white-color;\n\tbackground: $dark-blue-color;\n}\n.smallIcon {\n\twidth: 32px;  // 54px x .6\n\theight: 25px; // 41px x .6\n  color: $white-color;\n\tbackground: $dark-blue-color;\n}\n\n.entryForm {\n  height: 60px;\n  border-radius: 0 12px 12px 0;\n  font-size: 18px;\n}\n.smallEntryForm {\n  height: 40px;   // 57px x .6\n  border-radius: 0 8px 8px 0;\n  border-color: $gray-color;\n  border-width: 1px;\n  border-style: solid;\n  font-size: 15px;\n}\n\n.inputMessage {\n  text-align: start;\n  margin-left: 60px;\n  font-size: 16px;\n  color: $gray-color;\n}\n.smallInputMessage {\n  text-align: start;\n  margin: 1px 0 0 17px;\n  font-size: 13px;\n  color: $gray-color;\n}\n","$red-strongly-disagree-color: #eb5757;\n$orange-disagree-color: #ef8400;\n$orange-somewhat-disagree-color: #efba00;\n$yellow-neutral-color: #ffe921;\n$lime-somewhat-agree-color: #dde041;\n$green-agree-color: #94c556;\n$green-strongly-agree-color: #56c568;\n$gray-answer-circle-color: #686b6f;\n$black-color: #000;\n$gray-color: #aaaaaa;\n$gray-card-background: #f2f2f2;\n$gray-card-border: #bdbdbd;\n$light-gray-input-background: rgba(229, 229, 229, 0.18);\n$gray-input-border: #d9d9d9;\n$light-gray-lines: #cbc8c8;\n$gray-text: #8a8787;\n$orange-button: #f2994a;\n$orange-button-hover: #b06f35;\n$green-icon: #6fcf97;\n$green-bootstrap-success: #198753;\n$test: rgb(150,150,150);\n\n// from Hvar Rentals:\n$dark-blue-color: #154c79;\n$dark-blue-hover-color: #2066a0;\n$light-blue-color: #e4eef7;\n$white-color: #ffffff;\n// $black-color: #000;\n// $gray-color: #aaaaaa;\n$light-gray-color: #eee;\n$red-error-color: #cf062e;\n$test-green-color: #0f7c0b;\n\n$accent_color: orange;\n$bench-logo-anthracite: rgba(56, 57, 55); // #383937 - we use rgba for react-charts\n$bench-logo-anthracite-semi-transparent: rgba(56, 57, 55, 0.6);\n$bench-logo-anthracite-low-transparent: rgba(56, 57, 55, 0.35);\n$bench-logo-blue: rgba(73, 177, 227); // #49B1E3\n$bench-logo-orange: rgba(241, 121, 2); // #F17902\n$bench-logo-orange-semi-transparent: rgba(241, 121, 2, 0.5); // #F17902\n$bench-logo-red: rgba(190, 16, 32); // #BE1020\n$bench-logo-yellow: rgba(254, 213, 0); // #FED500\n$kultivierer-orange: #D27F20;\n$vmi-logo-red: #A6192E;\n\n$EO-Gesamtmodell-red: rgb(255, 0, 0); // #FF0000\n$EO-Gesamtmodell-red-semi-transparent: rgb(255, 0, 0, 0.04); // #FF0000\n$EO-Gesamtmodell-red-active: rgb(255, 0, 0, 0.06); // #FF0000\n$EO-Gesamtmodell-green: rgb(51, 153, 51); // #339933\n$EO-Gesamtmodell-green-semi-transparent: rgb(51, 153, 51, 0.05); // #339933\n$EO-Gesamtmodell-green-active: rgb(51, 153, 51, 0.07); // #339933\n//$EO-Gesamtmodell-gray: rgb(128, 128, 128); // #808080\n//$EO-Gesamtmodell-gray-semi-transparent: rgb(128, 128, 128, 0.9); // #808080\n$EO-Gesamtmodell-black: rgb(0, 0, 0); // #000000\n$EO-Gesamtmodell-black-semi-transparent: rgb(0, 0, 0, 0.04); // #000000\n$EO-Gesamtmodell-black-active: rgb(0, 0, 0, 0.06); // #000000\n\n\n// Note: join two classNames together like this:\n// <div className={styles.container + ' ' + styles.containerActive} />\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconInputUnit": `IconInputField_iconInputUnit__F1nUy`,
	"iconBackground": `IconInputField_iconBackground__zzwmJ`,
	"smallIconBackground": `IconInputField_smallIconBackground__g1LoH`,
	"icon": `IconInputField_icon__u3XxC`,
	"smallIcon": `IconInputField_smallIcon__EqSf5`,
	"entryForm": `IconInputField_entryForm__PX5Y5`,
	"smallEntryForm": `IconInputField_smallEntryForm__KVSlt`,
	"inputMessage": `IconInputField_inputMessage__C+mle`,
	"smallInputMessage": `IconInputField_smallInputMessage__POBNh`
};
export default ___CSS_LOADER_EXPORT___;
